import React from 'react';
import {useTranslation} from 'react-i18next';
import {mapWithIndex, blank, toDollar} from '@/util';

import {totalValuation} from '@/b2c/PlanDetail/Detail/PlanHolding';

const itemList = mapWithIndex((item, idx) => (
  <tr key={`case_holding_${idx}`}>
    <td>
      {item.currencyPrefix}
      {item.currency}
    </td>
    <td>{item.valueOn}</td>
    <td>{item.exchangeRate}</td>
    <td>{toDollar(item.value)}</td>
    <td>{toDollar(item.valuationValue)}</td>
  </tr>
));

const itemListRwd = (planCurrency, tr) =>
  mapWithIndex((item, idx) => (
    <li key={idx}>
      <strong>{item.currency}</strong>
      <table>
        <tbody>
          <tr>
            <td>
              {tr('valuation_date')} / {tr('exch_rate')}
            </td>
            <td>
              {item.valueOn} / {item.exchangeRate}
            </td>
          </tr>
          <tr>
            <td>{tr('in_original_currency')}</td>
            <td>{toDollar(item.value)}</td>
          </tr>
          <tr>
            <th>
              {tr('in_report_currency')} ({planCurrency})
            </th>
            <th>{toDollar(item.valuationValue)}</th>
          </tr>
        </tbody>
      </table>
    </li>
  ));

const CashHolding = ({planCurrency, data}) => {
  const {t: tr} = useTranslation('statements');

  if (blank(data)) {
    return null;
  }

  return (
    <section className='plan-details'>
      <h5>{tr('cash_balance')}</h5>

      {/* wide */}
      <table className='wide list text-left'>
        <tbody>
          <tr>
            <th>{tr('currency_type')}</th>
            <th>{tr('valuation_date')}</th>
            <th>{tr('exch_rate')}</th>
            <th>{tr('in_original_currency')}</th>
            <th>
              {tr('in_report_currency')} ({planCurrency})
            </th>
          </tr>
          {itemList(data)}
        </tbody>
      </table>

      {/* RWD */}
      <ul className='narrow list'>{itemListRwd(planCurrency, tr)(data)}</ul>

      <div className='subtotal clearfix' style={{width: '300px'}}>
        <div className='name'>
          <p>{tr('available_balance')}</p>
        </div>
        <div className='number'>
          <p>{toDollar(totalValuation(data))}</p>
        </div>
      </div>
    </section>
  );
};

export default CashHolding;
